const caseStudyComp = (gsap, scrollTrigger) => {
  
  const $csComp = $('.csf-desktop');
  
  if ($csComp.length) {
    
    const $studies = $('.csf-item');
    
    $studies.each(function() {
      const $this = $(this);
      const $img = $this.data('imgurl');

      $this.on('mouseenter', ()=> {
        if( !$this.hasClass('active') ) {
          $('.cs-follow img').attr("src", $img);
          $('.cs-follow').addClass('active');
          $('.csf-item.active').removeClass('active');
          $this.addClass('active');
        }
      });
    });

    scrollTrigger.addEventListener("scrollStart", () => {
      $('.cs-follow').removeClass('active');
      $('.csf-item.active').removeClass('active');
    }); 

    $('.csf-inline-wrap').on('mouseleave', (e)=> {
      $('.cs-follow').removeClass('active');
      $('.csf-item.active').removeClass('active');
    });

    $('.csf-inline-wrap').on('mousemove', (e)=> {
      gsap.to('.cs-follow', {
        duration: 0.3,
        ease: 'none',
        left: e.pageX,
        top: e.pageY
      })
      //$(".cs-follow").css({
      //  left: e.pageX,
      //  top: e.pageY
      //});
    })
        
  }
  
}

export {
  caseStudyComp
};